/* ==============================
   CWC Benefit Flip Cards
   Pure flip toggle — no accordion
   ============================== */

(function() {
  'use strict';

  function initFlipCards() {
    var sections = document.querySelectorAll('.cwc_benefit-flip-cards');

    sections.forEach(function(section) {
      var cards = section.querySelectorAll('.cwc_benefit-flip-cards__card');

      cards.forEach(function(card) {
        var toggleButtons = card.querySelectorAll('.cwc_benefit-flip-cards__card-toggle');

        toggleButtons.forEach(function(btn) {
          btn.addEventListener('click', function() {
            var isFlipped = card.classList.contains('is-flipped');

            /* Close all other cards in this section */
            cards.forEach(function(other) {
              if (other !== card && other.classList.contains('is-flipped')) {
                other.classList.remove('is-flipped');
                var otherFrontBtn = other.querySelector('.cwc_benefit-flip-cards__card-front .cwc_benefit-flip-cards__card-toggle');
                if (otherFrontBtn) {
                  otherFrontBtn.setAttribute('aria-expanded', 'false');
                }
              }
            });

            /* Toggle this card */
            if (isFlipped) {
              card.classList.remove('is-flipped');
              var frontBtn = card.querySelector('.cwc_benefit-flip-cards__card-front .cwc_benefit-flip-cards__card-toggle');
              if (frontBtn) frontBtn.setAttribute('aria-expanded', 'false');
            } else {
              card.classList.add('is-flipped');
              var frontBtn = card.querySelector('.cwc_benefit-flip-cards__card-front .cwc_benefit-flip-cards__card-toggle');
              if (frontBtn) frontBtn.setAttribute('aria-expanded', 'true');
            }
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlipCards);
  } else {
    initFlipCards();
  }

  document.addEventListener('shopify:section:load', initFlipCards);
})();
